(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService', '$cookies'];

    function Auth($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService, $cookies) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            updateAccount: updateAccount
        };

        var checkState = location.hash.split("/");
        $sessionStorage.previousStateName = checkState[checkState.length -1];
        if ($sessionStorage.previousStateName !== "general-settings" && $sessionStorage.previousStateName !== "settings")
            delete $sessionStorage.previousStateName;
        return service;

        function activateAccount(key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize(force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen(account) {
                var isAuthenticated = Principal.isAuthenticated();
                // an authenticated user with JOT_2FA cookie will be redirect to OTP page
                if (isAuthenticated && mustBeRedirectToOTP()) {
                    if ($rootScope.toState.name !== 'otp-code' && $rootScope.toState.name !== 'contact-us')
                        $state.go('otp-code');
                    return;
                }
                // an authenticated user without a selected context must be redirect to/ context page
                if (isAuthenticated && !Principal.hasContext() && $rootScope.toState.name !== 'context') {
                    $state.go('context');
                }
                // an authenticated user can't access to login and register pages
                if (isAuthenticated && ($rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register') ||
                    $rootScope.toState.parent === 'app' && $rootScope.toState.name === 'home' && account.authorities[0] == "ROLE_DOMAIN_USER")) {
                    if (account.authorities[0] == "ROLE_DOMAIN_USER" && account.context.licence.id != 4)
                        $state.go('tab-objects-dashboard');
                    else if ($rootScope.toState.name !== 'home')
                        $state.go('home'); //cambio stato solo dopo che la promise è stata risolta per evitare N chiamate parallele per la risoluzione degli state dell'app
                }


                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && $sessionStorage.previousStateName) {
                    var previousStateName = $sessionStorage.previousStateName;
                    var previousStateParams = $sessionStorage.previousStateParams;
                    delete $sessionStorage.previousStateName;
                    delete $sessionStorage.previousStateParams;
                    $state.go(previousStateName, previousStateParams);
                }

                if($rootScope.toState.data.authorities &&
                    $rootScope.toState.data.authorities.length > 0 &&
                    !Principal.hasAnyAuthority($rootScope.toState.data.authorities))
                {
                    notAuthorizedRedirect();
                } else if($rootScope.toState.data.evaluateAuthorities){
                    Principal.evaluate($rootScope.toState.data.evaluateAuthorities.replace(/\s+/g, ''))
                        .then(function (result) {
                            if(!eval(result)) {
                                notAuthorizedRedirect();
                            }
                    });
                }
            }
        }

        function notAuthorizedRedirect() {
            if (Principal.isAuthenticated()) {
                // user is signed in but not authorized for desired state
                $state.go('accessdenied');
            } else {
                // // user is not authenticated. stow the state they wanted before you
                // // send them to the login service, so you can return them when you're done
                // $sessionStorage.previousStateName = $rootScope.toState.name;
                // $sessionStorage.previousStateParams = $rootScope.toStateParams;
                //
                $state.go('login');
            }
        }

        function changePassword(newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout(true);
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                Principal.identity(true).then(function (account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account !== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    JhiTrackerService.sendActivity();
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout(skipRedirect) {
            AuthServerProvider.logout(skipRedirect);
            Principal.authenticate(null);

            // Reset state memory
            delete $sessionStorage.previousStateName;
            delete $sessionStorage.previousStateParams;
        }

        function resetPasswordFinish(keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit(mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount(account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function mustBeRedirectToOTP() {
            var OTPCookie = $cookies.get("JOT_2FA");
            return OTPCookie !== null && angular.isDefined(OTPCookie);
        }
    }
})();
